// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_CriarCompromissoWizardInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos/criar_compromisso_wizard
 *
 * Validates input for creating a new compromisso through the agenda wizard.
 */
import { registerContract } from './validate'

export interface Compromissos_CriarCompromissoWizardInput {
orcamento_id: number
cliente_id: number
operador_id: string
dataHoraInicio: string
dataHoraFim: string
forma_pagamento?: string
total?: number
servicos_ids?: number[]
}

registerContract('Compromissos_CriarCompromissoWizardInput', {
  orcamento_id:    { type: 'number',  required: true },
  cliente_id:      { type: 'number',  required: true },
  operador_id:     { type: 'string',  required: true },
  dataHoraInicio:  { type: 'string',  required: true },
  dataHoraFim:     { type: 'string',  required: true },
  forma_pagamento: { type: 'string',  required: false },
  total:           { type: 'number',  required: false },
  servicos_ids:    { type: 'array',   required: false },
})
